export default __webpack_public_path__ + "static/media/not_enabled_vision.e2e8bf52.png";